import CustomModal from './CustomModal';

interface PromotionalModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExploreNow: () => void;
  onNoThanks: () => void;
  dontShowAgain: boolean;
  setDontShowAgain: (value: boolean) => void;
}

export const PromotionalModal = ({
  isOpen,
  onClose,
  onExploreNow,
  onNoThanks,
  dontShowAgain,
  setDontShowAgain,
}: PromotionalModalProps) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      header={'Discover More While You Shop'}
      footer={
        <div className="w-full">
          <div className="flex justify-center gap-4 mb-4">
            <button
              className="bg-primary-blue-500 text-white px-6 py-2 rounded font-medium"
              onClick={onExploreNow}
            >
              Explore Now
            </button>
            <button
              className="bg-primary-blue-500 text-white px-6 py-2 rounded font-medium"
              onClick={onNoThanks}
            >
              No thanks
            </button>
          </div>
          {/* Checkbox */}
          <div className="flex justify-center">
            <label className="flex items-center space-x-2 text-sm text-gray-600">
              <input
                type="checkbox"
                className="form-checkbox h-4 w-4 text-blue-600"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
              />
              <span>Don't show me this again</span>
            </label>
          </div>
        </div>
      }
      modalSize={'w-full md:w-1/2 xl:w-1/3 max-sm:!p-0'}
    >
      <div className="text-center py-4">
        <p className="text-gray-700">
          Would you like to explore our non-prescription range of products?
          {/* Enjoy <span className="font-bold">15% OFF</span> our Non-Prescription
          Range until <span className="font-bold">October 31</span>. Enter code{' '}
          <span className="font-bold">THANKYOU15</span> at checkout to redeem
          your offer. */}
        </p>
      </div>
    </CustomModal>
  );
};
